function resizeWindow(){
	setTimeout(function() {
		equalize();
	}, 500);
}
function scrollDown(){

}

$(document).ready(function () {

	var smart_widget_open = false;
		$('.content-select select').change(function(){
			let thisVal = $(this).val();
			$(this).siblings('.dropdown').text(thisVal);
		})
    $("#pop-up--trigger-js").click(function(){
    	//$("#popup-gives-back__container").fadeToggle();
		$("#smart-booking__container").fadeToggle();
        if(smart_widget_open){
            return smart_widget_open = false;
        } else{
            return smart_widget_open = true;
        }
		});
    $("#smart-booking--trigger-js").click(function(){
		$("#popup-gives-back__container").fadeToggle();
        if(smart_widget_open){
            return smart_widget_open = false;
        } else{
            return smart_widget_open = true;
        }
		});
		$("#close-booking").click(function(){
		$("#smart-booking__container").fadeToggle();
        if(smart_widget_open){
            return smart_widget_open = false;
        } else{
            return smart_widget_open = true;
        }
		});
    $(document).keyup(function(e) {
        if (e.keyCode == 27 && smart_widget_open) {
            $("#smart-booking__container").fadeToggle();
            return smart_widget_open = false;
        }
    });

	//Call function with browser is resized.
    $(window).resize(function (event) {
         resizeWindow();
    });
    resizeWindow();

    //Acts when scroll down page.
    $(window).scroll(function (event) {
    	scrollDown();
		var top = ($('#header-img').height());

		if(innerWidth > 600){
			if ($(this).scrollTop() > top) {
				$('#content .content .sub-menu').addClass('navbar-fixed');
			} else {
				$('#content .content .sub-menu').removeClass('navbar-fixed');
			}
		}
		
/*
		var $document = $(document);
		if ($document.scrollTop() >= 35) {
			$('#header').addClass('scroll', 0);
			$('.room_entry #content .content .sub-menu').addClass('navbar-fixed');
		} else {
			$('#header').removeClass('scroll', 0);
			$('.room_entry #content .content .sub-menu').removeClass('navbar-fixed');
		}
*/
	});

	// Main Nav Dropdown
    $("#primary-nav li").hover(function(){

        $(this).addClass("hover");
        $('ul.submenu',this).fadeIn(200);

    }, function(){

        $(this).removeClass("hover");
        $('ul.submenu',this).fadeOut(200);

    });
    
    /*** tablet nav ***/
    $('.menu-trigger').click(function(){
		if ($(this).hasClass('open')){
			$('#header .tablet-primary').fadeOut(); 
			var text = $(this).text();
			$('.menu-text').text('Menu');
			$('.menu-holder').addClass('close');
			$('#header .menu-holder .menu-text').removeClass('scroll');
		} else {
			$('#header .tablet-primary').fadeIn();
			var text = $(this).text();
			$('.menu-text').text('Close');
			$('#header .menu-holder .menu-text').addClass('scroll');
			$('.menu-holder').removeClass('close');
			if($('.navigation ul li a').hasClass('active')){
				$(".item-open").get(0);
			}
		}
	});
	$('.menu-trigger').click(function(){
		$(this).toggleClass('open');
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function(event) {
	    $('body, html').animate({
	        scrollTop: $(window).height()-$('header').outerHeight()*2},
	        800, 'easeOutExpo');
	});
	
	$(".tabs-menu a").click(function(event) {
        event.preventDefault();
        $('.tabs-menu a').removeClass("active");
        $(this).addClass("active");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
        $('.sym-slides').slick('unslick');
	    $('.sym-slides').slick({
			arrows: true,
			dots: false,
			autoplay: false,
			autoplaySpeed: 4000,
			speed: 500,
			fade: true,
			accessibility: false
		});
		setTimeout(function() {
			equalize();
		}, 50);
    });
    
    $('.read-more-blog').click(function(e) {
	    $(this).next('div.blog-full').slideToggle();
	    var text = $(this).text();
		$(this).text(text == "Show Less -" ? "Read More +" : "Show Less -");
	});
    
    $('.see-more').click(function(e) {
	    $('.hidden-insta').fadeToggle();
	    var text = $(this).text();
		$(this).text(text == "Show Less -" ? "See More +" : "Show Less -");
    });
    /**---
    $('.check-avail').click(function(){
	    $('.booking-holder').fadeIn();
    });
    $('.close-booking').click(function(){
	    $('.booking-holder').fadeOut();
    });
    --*/
    
    //Rooms navigation active states
    if($('.room_entry.grand-canal-deluxe-suite, .room_entry.grand-canal-deluxe-two-bedroom-suite, .room_entry.grand-canal-deluxe-three-bedroom-suite').length > 0) {
	    $('#primary-nav ul li.primary-nav-1 a').addClass('active');
	    $('#content .content .sub-menu ul li:nth-child(2) a').addClass('active');
    }
    
    if($('.room_entry.lagoon-beach-suite').length > 0) {
	    $('#primary-nav ul li.primary-nav-1 a').addClass('active');
	    $('#content .content .sub-menu ul li:nth-child(3) a').addClass('active');
    }
    
    if($('.room_entry.studio-one-queen-bed,.room_entry.studio-two-queen-bed').length > 0) {
	    $('#primary-nav ul li.primary-nav-1 a').addClass('active');
	    $('#content .content .sub-menu ul li:nth-child(4) a').addClass('active');
    }
    
    if($('.room_entry.hotel-bedroom').length > 0) {
	    $('#primary-nav ul li.primary-nav-1 a').addClass('active');
	    $('#content .content .sub-menu ul li:nth-child(5) a').addClass('active');
    }
    
    $('.top-gallery').slick({
		dots: false,
		fade: true,
		arrows: false,
	  	slidesToShow: 1,
	  	slidesToScroll: 1,
	  	asNavFor: '.mini-gallery ul',
	  	accessibility: false
	});

	$('.mini-gallery ul').slick({
		dots: false,
		arrows: true,
		asNavFor: '.top-gallery',
	  	slidesToShow: 3,
	  	slidesToScroll: 1,
	  	focusOnSelect: true,
	  	accessibility: true
	});
    
    //Remove empty p tags with spaces or breaks
	$('p').each(function() {
	    var $this = $(this);
	    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
	        $this.remove();
	});
	
	$('#content .content li, #home #content ul li').wrapInner('<span></span>');
	
	$('.inquiry-form').click(function(){
		$('.activity-inquiry').fadeToggle();
	});
	$('.close-inquiry').click(function(){
		$('.activity-inquiry').fadeOut();
	});
	
	$('#amenityMenu dl dt a#nightlife').html('Sandyport Beach Resort');
	
	//Event Tracking
    $('.book-now').on('click', function () {
         ga('send', 'event', 'reservations', 'click', 'book now');
    });
    $('.bookNow').on('click', function () {
         ga('send', 'event', 'header widget', 'click', 'book now');
    });

  /***
	//Check in and check out datepicker for booking engine
	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		dateFormat : 'd'+' '+'M'+'     '+'y',
		altField: "#check_in_alt",
		altFormat: 'yy-mm-dd',
		changeMonth: true,
		numberOfMonths: 1,
		minDate: 0,
		onSelect: function( selectedDate ) {
			getDate = $(this).datepicker('getDate');
        	newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut" ).datepicker( "setDate", newDate );
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		dateFormat : 'd'+' '+'M'+'     '+'y',
		altField: "#check_out_alt",
		altFormat: 'yy-mm-dd',
		changeMonth: true,
		numberOfMonths: 1,
		onSelect: function( selectedDate ) {
			$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		}
	});
	--*/
	
	// Map: Return to previous page button. Change body id to match map template's name.
	$('body#map-category #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	
	//landing-page-countdown
	if($('#landing-page-countdown').length > 0){
		$('#primary-nav, .check-avail').remove();
		$('.countdown').insertAfter($('#header .logo'));
	}


});

$(window).on('load', function() {

   	//Slick Slider
	$('.sym-slides').slick();

	if (window.location.href.indexOf('specials#special5349') > 0){ 
		$('#special5349').addClass('special__featured');
	}
	
	
});

// simulate a "window.location.search" string.
var testurl = "?slick0=3&slick1=2";

$(".other-specials")
    .slick()
    .each(function(){
        
        //if( window.location.search ) {
        if( testurl ) {
            
            var $slider = $(this),
                sliderid = $slider.getSlick().instanceUid,
                //queries = window.location.search.slice(1).split("&"),
                queries = testurl.slice(1).split("&"),
                checkQuery;
            
            for( query in queries ) {
                checkQuery = queries[query].split("=");
                if( checkQuery[0] === "slick"+sliderid ) {
                    $slider.slickGoTo( parseInt(checkQuery[1],10) );
                }
            }
        }

	});
//
